import React, { Component } from 'react';
import {showSuccessMsg} from '../../util/messagesUtil';

export class BotaoAtivarOuInativar extends Component {

    ativarOuInativar = () => {        
        const operacaofinalizada = (mensagem) => {
            showSuccessMsg(mensagem);
            this.props.fecharModal();
            this.props.buscarItinerarios()
        }

        if(this.props.ativo) {            
            this.props.inativarItinerario(this.props.idEmpresa, this.props.idItinerario)
                .then(() => {
                    operacaofinalizada('Itinerário desativado com sucesso.');                    
                });
        } else {
            this.props.ativarItinerario(this.props.idEmpresa, this.props.idItinerario)
                .then(() => {
                    operacaofinalizada('Itinerário ativado com sucesso.');                    
                });
        }
    }

    render() {        
        return (
            <button type='button' onClick={this.ativarOuInativar} className={this.props.ativo ? 'btn btn-outline-danger' : 'btn btn-outline-success'}>
                {this.props.ativo ? 'Inativar' : 'Ativar' }
            </button>
        );
    }
}